/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from 'react';
import { Chip, type ChipSizeTypes, Tooltip } from '@saviynt/design-system';

import { TABS_FILTERS } from '../../constants';
import { useInvertedLocalize } from '../../hooks';

interface SodStatusChipProps {
  kind: ChipSizeTypes;
  tabInAction: string;
  isDashReturn?: boolean;
  className?: string;
}

/**
 * Chip for the violation status
 */
function SodStatusChip({
  kind,
  tabInAction,
  isDashReturn,
  className,
}: SodStatusChipProps) {
  const l = useInvertedLocalize();

  const tab = Object.values(TABS_FILTERS).find((t) => t.value === tabInAction);

  if (!tab) {
    return isDashReturn ? '-' : null;
  }

  const { label, color } = tab;

  return (
    <Tooltip
      trigger={
        <Chip
          label={l(label)}
          kind='subtleFilled'
          color={color}
          size={kind}
          className={className}
        />
      }
      text=''
      placement='bottom'
    />
  );
}

SodStatusChip.defaultProps = {
  isDashReturn: false,
  className: null,
};

export default SodStatusChip;
